<template>
  <el-dialog custom-class="medium-dialog" title="购物车" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true" @close="closeDialog">
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-light">
          <!--<div>-->
          <div class="search-content">
            <el-col :span="24" class="toobar">
              <el-date-picker size="small" style="width:215px;"
                              v-model="searchdatevalue"
                              type="daterange" :value-format="'yyyy-MM-dd'"
                              align="left" :unlink-panels="true"
                              range-separator="至" :clearable="false"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
              </el-date-picker>
              <el-checkbox v-model="chkAll" @change="showPas">全部客户</el-checkbox>
              <el-button type="primary" icon="el-icon-search" @click="bindGrid()">搜索</el-button>
            </el-col>
          </div>
          <el-table :data="tableData" ref="table1"
                    size="mini" stripe border style="width: 100%;">
            <el-table-column
              width="60"
              label="序号"
              align="center">
              <template slot-scope="scope">
                {{1+scope.$index}}
              </template>
            </el-table-column>
            <el-table-column
              prop="customerserial"
              label="编码"
              align="left" :show-overflow-tooltip="true"
              header-align="center"
              width="150">
            </el-table-column>
            <el-table-column
              prop="pcustomer"
              label="名称" :show-overflow-tooltip="true"
              align="left"
              header-align="center">
            </el-table-column>
            <el-table-column
              prop="totalnumber"
              label="数量"
              align="left"
              header-align="center"
              width="140">
            </el-table-column>
            <el-table-column  label="操作"  align="center" width="80">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="warning"
                  @click="handleSel(scope.$index, scope.row)">选择
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!--</div>-->
      </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
  import {listShopSub} from '@/api/order/shopping';

  export default {
    name: 'Shoppingsub',
    data() {
      return {
        searchdatevalue: [],
        chkAll: false,
        dialogFormVisible: false,
        loading: true,
        tableData: [],
      }
    },
    methods: {
      closeDialog() {
        // this.$emit("afterCloseDialog", [])
      },
      show() {
        this.dialogFormVisible = true;
        this.tableData = [];
        this.bindGrid();
      },
      bindGrid() {
        if (this.searchdatevalue == null || this.searchdatevalue == '') {
          this.$message({
            message: '日期范围必须选择！',
            type: 'error'
          })
          return;
        }
        var startDate = new Date(this.searchdatevalue[0]);
        var endDate = new Date(this.searchdatevalue[1]);

        var userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
        listShopSub({
          uguid: this.chkAll?"":userInfoModel.uguid,
          begindate: startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + "-" + startDate.getDate(),
          enddate: endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + "-" + endDate.getDate()+" 23:59:59",
        }).then(response => {
          this.tableData = response.data.obj;
        }).catch((error) => {
          console.log(error)
        });
      },
      handleSel(index, row) {//单选
        this.$emit("afterSelectShop", row)
        this.dialogFormVisible = false
      },
    },
    mounted() {
      var end = new Date();//当天
      this.searchdatevalue = [end, end];
    },
    components: {}
  }
</script>


<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/Shoppingsub.vue